import { render, staticRenderFns } from "./pdproduct1.vue?vue&type=template&id=6bb4e41a&scoped=true"
import script from "./pdproduct1.vue?vue&type=script&lang=js"
export * from "./pdproduct1.vue?vue&type=script&lang=js"
import style0 from "./pdproduct1.vue?vue&type=style&index=0&id=6bb4e41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4e41a",
  null
  
)

export default component.exports